import React from 'react';
import { Helmet } from 'react-helmet';

import { configValues } from 'src/config';

interface HeaderProps {
  title: string;
  description?: string;
  url?: string;
}

const Header = ({ title, description, url }: HeaderProps) => (
  <Helmet>
    <title>SEEK Business - {title}</title>
    <meta property="og:title" content={title} />
    {description && <meta name="description" content={description} />}
    {description && <meta property="og:description" content={description} />}
    {url && (
      <meta
        property="og:url"
        content={`${configValues.HEADER_SERVER_BASE}${url}`}
      />
    )}
    {url && (
      <link rel="canonical" href={`${configValues.HEADER_SERVER_BASE}${url}`} />
    )}
  </Helmet>
);

export default Header;
